import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TravelCommissionsService {
  private url = `${environment.reportApiUrl}/travel-commissions`;

  constructor(private api: ApiService) {}

  getTravelCommissions() {
    return this.api.get(`${this.url}`);
  }

  postTravelCommissions(month: string, file: File) {
    const formData = new FormData();
    formData.append('month', month);
    formData.append('file', file);

    return this.api.postFormData(`${this.url}/add`, formData);
  }

  deleteTravelCommissions(id) {
    return this.api.delete(`${this.url}/delete/${id}`);
  }

  downloadPdf(id) {
    return this.api.getBlob(`${this.url}/download/${id}`);
  }
}
